/* eslint-disable */
//tslint:disable

import { IOfferPhotoSchema } from '../photo/OfferPhotoSchema';

export interface IOfferV2Schema {
  /** Список удобств, включенных в цену объявления **/
  amenities: EAmenities[];
  /** Площадь **/
  area: number;
  /** Cian ID объявления **/
  cianId: number;
  /** Тип объявления в коворкинге **/
  coworkingOfferType: ECoworkingOfferType;
  /** Полная ссылка на карточку **/
  fullUrl: string;
  /** Realty ID объявления **/
  id: number;
  /** Телефон, указанный в объявлении **/
  phone: string;
  /** Список картинок объявления **/
  photos: IOfferPhotoSchema[];
  /** Цена за весь офис, руб/месяц **/
  priceAllPerMonth: number;
  /** Цена за рабочее место, руб/месяц **/
  priceForWorkplace: number;
  /** Количество рабочих мест **/
  workplaceCount: number;
}

export enum EAmenities {
  /** Велопарковка **/
  BikeParking = 'bikeParking',
  /** Кафе **/
  Cafe = 'cafe',
  /** Клининг **/
  Cleaning = 'cleaning',
  /** Участие в мероприятиях **/
  Events = 'events',
  /** Факс **/
  Fax = 'fax',
  /** Флипчарт **/
  Flipchart = 'flipchart',
  /** Фрукты и закуски **/
  Fruits = 'fruits',
  /** Мебель **/
  Furniture = 'furniture',
  /** Спорт-зал **/
  Gym = 'gym',
  /** Высокоскоростной интернет **/
  Internet = 'internet',
  /** Кухня **/
  Kitchen = 'kitchen',
  /** Юридический адрес **/
  LegalAddress = 'legalAddress',
  /** Шкафчики **/
  Lockers = 'lockers',
  /** Переговорные комнаты **/
  MeetingRoom = 'meetingRoom',
  /** Микрофон **/
  Microphone = 'microphone',
  /** Современный ремонт **/
  Modern = 'modern',
  /** Парковка **/
  Parking = 'parking',
  /** Телефонные будки **/
  PhoneBooth = 'phoneBooth',
  /** Принтер и сканер **/
  Printer = 'printer',
  /** Проектор **/
  Projector = 'projector',
  /** Ресепшн **/
  Reception = 'reception',
  /** Зоны отдыха **/
  RestZone = 'restZone',
  /** Охрана **/
  Security = 'security',
  /** Шумопоглощающие панели **/
  SoundAbsorbingPanels = 'soundAbsorbingPanels',
  /** Чай/кофе **/
  Tea = 'tea',
  /** Техническая поддержка **/
  TechSupport = 'techSupport',
  /** Wi-Fi **/
  Wifi = 'wifi',
}
export enum ECoworkingOfferType {
  /** Закрепленное рабочее место **/
  FixedWorkplace = 'fixedWorkplace',
  /** Незакрепленное рабочее место **/
  FlexibleWorkplace = 'flexibleWorkplace',
  /** Гибкий офис **/
  Office = 'office',
}
